const HERO_SELECTOR = '.template-hero';

/**
 * Парение плашек hero — CSS-анимация (templates/_hero.scss): её ведёт
 * композитор, и на Windows она не дёргается, как прежний покадровый
 * transform из requestAnimationFrame. Скрипту остаётся одно — ставить
 * анимацию на паузу, пока hero за пределами экрана.
 */
export default function HeroMetricsFloat() {
    const hero = document.querySelector(HERO_SELECTOR);

    if (!hero || !hero.querySelector('[data-hero-float]') || !('IntersectionObserver' in window)) {
        return;
    }

    new IntersectionObserver((entries) => {
        hero.classList.toggle('is-offscreen', !entries[0].isIntersecting);
    }).observe(hero);
}
